import React from 'react';
import { Margin, Padding } from '../../view-model/Spacing';
import {
  AlignItemsOptions,
  ContentOptions,
  FlexOptions,
  JustifyOptions,
  SelfOptions,
} from '../../view-model/Flex';
import { getClassNames } from '../../helpers/Box';
import { BgColor } from '../../view-model/Colors';
import { BorderRadius } from '../../view-model/BorderRadius';

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: Padding | Padding[];
  margin?: Margin | Margin[];
  flex?: FlexOptions | FlexOptions[];
  justify?: JustifyOptions;
  alignItems?: AlignItemsOptions;
  self?: SelfOptions;
  content?: ContentOptions;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  children?: React.ReactNode;
  background_color?: BgColor;
  id?: string;
  border_raduis?: BorderRadius;
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({
    className = '',
    children,
    id,
    padding,
    margin,
    flex,
    justify,
    alignItems,
    self,
    content,
    background_color,
    border_raduis,
    ...rest
  }: BoxProps): React.ReactElement => {
    const classNames = getClassNames({
      padding,
      margin,
      flex,
      justify,
      alignItems,
      self,
      content,
      background_color,
      border_raduis
    }).join(' ');
    const combinedClassName = [classNames, className].filter(Boolean).join(' ');
    return (
      <div id={id} className={combinedClassName} {...rest}>
        {children}
      </div>
    );
  },
);
export default Box;
